import type { AnalyticsPlacementTypes } from '@core/analytics'

/** Shared payload shape for the player's placement-tagged events (`audio` + `player_placement`). */
export type TPlayerPlacementPayload = {
    audio: string
    params__key: ['player_placement']
    params__str_value: [AnalyticsPlacementTypes]
}

export type TPlaybackEventPayload = TPlayerPlacementPayload & { collection?: string }

export const playerPlacementPayload = (
    audio: string,
    placement: AnalyticsPlacementTypes,
): TPlayerPlacementPayload => ({
    audio,
    params__key: ['player_placement'],
    params__str_value: [placement],
})

export const playbackEventPayload = (
    audio: string,
    placement: AnalyticsPlacementTypes,
    collectionId: string | undefined,
): TPlaybackEventPayload => ({
    audio,
    ...(collectionId ? { collection: collectionId } : {}),
    params__key: ['player_placement'],
    params__str_value: [placement],
})
